/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import * as LAYOUT_TYPE from '../../constants/layout-types';
import MemberBox from '../../containers/member-box';
import styles from './member-list-desktop.scss';

const classNames = require('classnames');

const MemberListDesktop = ({ membersIds, ...props }) => (
  <div>
    <div className={classNames(styles.wrapper, props.layoutStyle === LAYOUT_TYPE.LAYOUT_GRID_VIEW && styles.gridView)}>
      {membersIds.map((memberId) => (
        <MemberBox memberId={memberId} key={memberId} className={styles.fullWidth} {...props} />
      ))}
    </div>
  </div>
);

MemberListDesktop.propTypes = {
  membersIds: PropTypes.array.isRequired,
};

export default MemberListDesktop;
